/*
 * Mutation to set access token in Vuex and Cookie
 */
export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";

/**
 * Mutation to set id token in Vuex and Cookie
 */
export const SET_ID_TOKEN = "SET_ID_TOKEN";

/**
 * Mutation to set refresh token in Vuex and Cookie
 */
export const SET_REFRESH_TOKEN = "SET_REFRESH_TOKEN";

/*
 * Mutation to remove access token in Vuex and Cookie
 */
export const REMOVE_ACCESS_TOKEN = "REMOVE_ACCESS_TOKEN";

/**
 * Mutation to remove id token in Vuex and Cookie
 */
export const REMOVE_ID_TOKEN = "REMOVE_ID_TOKEN";

/**
 * Mutation to remove refresh token in Vuex and Cookie
 */
export const REMOVE_REFRESH_TOKEN = "REMOVE_REFRESH_TOKEN";

/**
 * Mutation to show/hide the search bar in Vuex
 */
export const TAGGLE_SEARCH_BAR = "TAGGLE_SEARCH_BAR";

/**
 * Mutation to show/hide the hamburger menu in Vuex
 */
export const TAGGLE_HAMBURGER_MENU = "TAGGLE_HAMBURGER_MENU";
